import React, { useState } from "react";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import BasicModal from "../../core/BaseComponents/Modal";

const BgConfigList = (props) => {
    const [showPreviewPopUp, setShowPreviewPopUp] = useState('');
    const columns = [
        { field: "createOn", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
        { field: "bgTitle", headerName: "Background Title", flex: 1 },
        { field: "types", headerName: "Room Types", flex: 1, row: true, renderCell: (row) => row?.types?row?.types?.map((item, index) => <span>{index ? ',' : ''} {item}</span>):'N.A' },
        { field: 'bgUrl', headerName: 'Background Image', flex: 1, row: true, renderCell: (row) => (<img src={row?.bgUrl} alt={row?.sid} className="background-config-img" onClick={() => setShowPreviewPopUp(row?.bgUrl)} />), disableSortIcon: true, },
    ];

    return (
        <div className="hotel-list">
            <p><b>Background Image Details</b></p>
            <TableWrapper
                data={[props?.fetchCDSNBgConfigList]}
                columns={columns}
                noPagination={true}
            />
            {showPreviewPopUp !== "" && <BasicModal
                popupOpen={showPreviewPopUp}
                popupCloseHandler={() => { setShowPreviewPopUp('') }}
                isCross={true}
                heading={'Background Image Preview'}
                popupSize='col-8 px-5'
                bodyMessage={
                    <div className="preview-banner-img">
                        <img src={showPreviewPopUp} alt='bg-image' width={100} />
                    </div>
                }
            />}
        </div>
    )
}

export default BgConfigList;